import { useParams } from "react-router-dom";
import InfoChip from "../components/common/InfoChip";
import { Severity } from "../types";
import { useFetchCityDetailsQuery, useUpdateCityMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import { citySchema } from "../configs";
import CityForm from "../forms/City.form";

const EditCityWrapper = () => {
  const { cityId } = useParams();

  if (!cityId)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Ville Introuvable"
      />
    );

  return <EditCity cityId={cityId} />;
};

interface EditCityProps {
  cityId: string;
}

const EditCity: React.FC<EditCityProps> = ({ cityId }) => {
  const [updateCity, { isLoading }] = useUpdateCityMutation();
  const { data: cityDetails, isFetching } = useFetchCityDetailsQuery(cityId);

  if (isLoading || isFetching) return <div> loading... </div>;

  if (!cityDetails)
    return (
      <InfoChip
        severity={Severity.DANGER}
        content="Ville Introuvable"
      />
    );

  return (
    <div className="w-full flex flex-col items-center p-4">
      <CityForm
        initialValues={cityDetails}
        validationSchema={citySchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          values.coordinates = values.coordinates.map((c: string) => +c);
          const result = await updateCity({
            cityId,
            body: values,
          });
          if (!result.error) {
            showToast("Ville mise à jour", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default EditCityWrapper;
